<script>
import ElementResizeDetector from 'element-resize-detector'

export default {
  props: {
    refresh: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      width: null,
      height: null
    }
  },

  watch: {
    refresh() {
      this.refreshDimensions()
    }
  },

  mounted() {
    const erd = ElementResizeDetector({ strategy: 'scroll' })
    erd.listenTo(this.$el, (el) => {
      this.$debounce(this.refreshDimensions(el), 10)
    })
    this.$nextTick(() => {
      this.refreshDimensions()
    })
  },

  methods: {
    onHeightChanged(newValue) {
      if (newValue !== this.height) {
        this.$emit('height-changed', {
          newValue,
          oldValue: this.height
        })
        this.height = newValue
      }
    },

    onWidthChanged(newValue) {
      if (newValue !== this.width) {
        this.$emit('width-changed', {
          newValue,
          oldValue: this.width
        })
        this.width = newValue
      }
    },

    refreshDimensions(element) {
      element = element || this.$el
      const rect = element.getBoundingClientRect()
      this.onWidthChanged(rect.width || element.clientWidth)
      this.onHeightChanged(rect.height || element.clientHeight)
    }
  },

  render() {
    return this.$scopedSlots.default({
      width: this.width,
      height: this.height,
      refreshHeight: () => this.onHeightChanged(this.$el.getBoundingClientRect().height || this.$el.clientHeight),
      refreshWidth: () => this.onWidthChanged(this.$el.getBoundingClientRect().width || this.$el.clientWidth)
    })
  }
}
</script>
